import Ellipsis from "@/components/views/Ellipsis";
import { AnonymousContentWrapper } from "@/components/wrappers/AnonymousContentWrapper";
import { getAppName } from "@/utils/utils";
import { Card, QRCode } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import appStoreBadge from "../../../assets/images/apple-app-store-badge.svg";
import playStoreBadge from "../../../assets/images/google-play-store-badge.png";
import { AppName } from "../../../common/constants";
import styles from "./MobileApp.module.scss";

const getMobileAppName = (appName: AppName) => {
  switch (appName) {
    case AppName.CLIIP:
      return "Cliip";
    case AppName.PROFIT:
      return "MyProfit";
    default:
      return "Cliip";
  }
};

const getGooglePlayAppUrl = (appName: AppName) => {
  let mobileApp: string;

  switch (appName) {
    case AppName.CLIIP:
      mobileApp = "sk.itgo.cliip";
      break;
    case AppName.PROFIT:
      mobileApp = "sk.vzdyviac.myprofit";
      break;
    default:
      mobileApp = "sk.itgo.cliip";
      break;
  }

  return `https://play.google.com/store/apps/details?id=${mobileApp}`;
};

const getAppleAppStoreUrl = (appName: AppName) => {
  let mobileApp: string;

  switch (appName) {
    case AppName.CLIIP:
      mobileApp = "cliip/id1578258553";
      break;
    case AppName.PROFIT:
      mobileApp = "myprofit/id6760868887";
      break;
    default:
      mobileApp = "cliip/id1578258553";
      break;
  }

  return `https://apps.apple.com/sk/app/${mobileApp}`;
};

export const MobileApp = () => {
  const { t } = useTranslation();

  const appName = getAppName();
  const mobileAppName = getMobileAppName(appName);

  return (
    <AnonymousContentWrapper>
      <Card
        className="card-box"
        title={<Ellipsis className={styles.title}>{t("pages.mobileApp.title", { mobileAppName })}</Ellipsis>}
      >
        <p className={classNames(styles.appInfo, "margin-bottom-medium")}>{t("pages.mobileApp.text1")}</p>

        <p className={classNames(styles.downloadInfo, "margin-bottom-tiny")}>{t("pages.mobileApp.text2")}</p>

        <div className={styles.badges}>
          <a href={getGooglePlayAppUrl(appName)} target="_blank" rel="noreferrer">
            <img className={styles.badge} src={playStoreBadge} alt="Google play badge" />
          </a>

          <a href={getAppleAppStoreUrl(appName)} target="_blank" rel="noreferrer">
            <img className={styles.badge} src={appStoreBadge} alt="Apple App Store badge" />
          </a>
        </div>

        <p className={classNames(styles.qrInfo, "margin-bottom-small")}>{t("pages.mobileApp.text3")}</p>

        <div className={styles.qrCodes}>
          <QRCode className={styles.qrCode} type="svg" value={getGooglePlayAppUrl(appName)} />

          <QRCode className={styles.qrCode} type="svg" value={getAppleAppStoreUrl(appName)} />
        </div>
      </Card>
    </AnonymousContentWrapper>
  );
};
